<template>
    <v-row no-gutters>

        <v-col cols="12" xs="12" md="12">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="entities"
                :search="search"
                :options="options"
                :footer-props="{ itemsPerPageOptions: [5, 10, 20] }"
                :page.sync="options.page"
                @page-count="paginationPageCount = $event"
                @dblclick:row="(event, data) => $eventBus.$emit('on-templates-module-action', { action: 'OpenRequisitesGroup', object: data.item })"
                class="elevation-1 customization-list-table pagination-list-table sticky-table"
            >

                <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate />

                <template v-slot:[`item.Value`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.Value">
                                {{ item.Value }}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`footer.prepend`]>
                    <v-pagination
                        v-model="options.page"
                        :length="paginationPageCount"
                        :total-visible="$listPaginationTotal"
                        color="teal"
                    ></v-pagination>
                </template>

            </v-data-table>
        </v-col>

    </v-row>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
import sys from "@/services/system";

export default {
    columnIndex:  {
        'document_type': 1,
        'template_name': 2
    },
    props: {
        search: {
            type: String,
            default: ""
        }
    },
    computed: {
        collection() {
            return this.$store.getters['templates/getCollection'];
        },
        headers() {
            return [
                { text: this.$t("Наименование"), value: 'Value' }
            ];
        },
        options: {
            get: function() {
                return this.$store.getters['templates/requisitesGroups/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('templates/requisitesGroups/SET_TABLE_OPTION', newValue);
            }
        }
    },
    data() {
        return {
            loading: true,
            total: 0,
            entities: [],
            paginationPageCount: 0,
        }
    },
    methods: {
        dateFormat: sys.dateFormat,
        resetPage() {
            this.$store.commit('templates/requisitesGroups/SET_TABLE_OPTION_PAGE', 1);
        },
        async getData() {
            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `api/templates/list?collection=${this.collection}`,
                method: 'GET',
                headers: { "isCommon": true }
            });

            this.entities = response?.data?.payload?.data ?? [];
            this.total = response?.data?.payload?.total ?? 0;
            this.loading = false;
        }
    },
    created() {
        this.getData();
    }
}
</script>
